import { checkStateHasReportData, useCMAStore } from 'features/CMA/infra/react/CMAState'
import { DistanceFilterDropdownDumb } from 'presentation/screens/CompsScreen/components/CompsFilterBar/components/DistanceFilterDropdown/DistanceFilterDropdown.dumb'
import { DistanceFilterDropdownDumbProps } from 'presentation/screens/CompsScreen/components/CompsFilterBar/components/DistanceFilterDropdown/DistanceFilterDropdown.dumb.props'

type Props = DistanceFilterDropdownDumbProps

export const DistanceFilterDropdown = () => {
  const reportState = useCMAStore(state => state.local.report)
  const filterComps = useCMAStore(state => state.actions.filterComps.execute)

  const handleOnValueChange: Props['onChange'] = value => {
    void filterComps({
      distanceMiles: value,
    })
  }

  if (!checkStateHasReportData(reportState)) return null

  const value = reportState.data.filters.distanceMiles

  return (
    <DistanceFilterDropdownDumb
      value={value}
      onChange={handleOnValueChange}
    />
  )
}
